import EventEmitter from "events";

const eventEmitter = new EventEmitter();
eventEmitter.setMaxListeners(100); // roughly 25 notes or memory leak

export { eventEmitter };
